var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      attrs: {
        dark: "",
        permanent: "",
        "mini-variant": !_vm.expand,
        "mini-variant-width": _vm.miniVariantWidth,
        app: "",
        width: 300,
        src: `data:image/jpeg;base64,${_vm.barImg}`
      },
      scopedSlots: _vm._u([
        {
          key: "img",
          fn: function(props) {
            return [
              _c(
                "v-img",
                _vm._b(
                  { attrs: { gradient: `to top, ${_vm.barColor}` } },
                  "v-img",
                  props,
                  false
                )
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "v-list",
        {
          staticStyle: { "-webkit-app-region": "no-drag" },
          attrs: { nav: "" }
        },
        [
          _c(
            "v-list-item",
            {
              attrs: {
                to: "/",
                disabled: _vm.$store.getters["auth/mainPageV2"] !== "/",
                "active-class": "primary",
                value: 0
              }
            },
            [
              _c("v-list-item-icon", [_c("v-icon", [_vm._v("mdi-home")])], 1),
              _c(
                "v-list-item-content",
                [_c("v-list-item-title", [_vm._v("VDEMTECH")])],
                1
              )
            ],
            1
          ),
          _c("v-divider", { staticClass: "mb-2" }),
          _vm._l(_vm.routes, function(item, index) {
            return [
              item.children
                ? _c(
                    "v-list-group",
                    {
                      staticClass: "cstm-slide-left",
                      style: `animation-delay: ${index * 0.1}s`,
                      attrs: {
                        "no-action": "",
                        "active-class": "white--text primary"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function() {
                              return [
                                _c(
                                  "v-list-item-icon",
                                  [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                                  1
                                ),
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(item.title))
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    _vm._l(item.children, function(child, childIndex) {
                      return _c(
                        "v-list-item",
                        {
                          key: childIndex,
                          attrs: {
                            link: "",
                            value: index * 10 + (childIndex + 1),
                            "active-class": "white--text yellow darken-4",
                            to: child.to
                          }
                        },
                        [
                          _c("v-list-item-avatar", [
                            _vm._v(_vm._s(child.title.substr(0, 1)))
                          ]),
                          _c("v-list-item-title", {
                            domProps: { textContent: _vm._s(child.title) }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c(
                    "v-list-item",
                    {
                      staticClass: "cstm-slide-left",
                      style: `animation-delay: ${index * 0.1}s`,
                      attrs: {
                        to: item.to,
                        link: "",
                        value: index + 1,
                        "active-class": "primary"
                      }
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", {
                            domProps: { textContent: _vm._s(item.icon) }
                          })
                        ],
                        1
                      ),
                      _c("v-list-item-title", {
                        domProps: { textContent: _vm._s(item.title) }
                      })
                    ],
                    1
                  )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }